import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from './sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './table.css';
import { toast, ToastContainer } from 'react-toastify';// Import Toastify
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS
const ExpiredVendors = () => {
  const [vendors, setVendors] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
 const [showModal, setShowModal] = useState(false);
  const [onboardVendorId, setOnboardVendorId] = useState('');
    const [businessType, setBusinessType] = useState('');
    const [expiryDays, setExpiryDays] = useState('');
    const [startDate, setStartDate] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/ExpiredVendor`);
        if (response.data.status === 'ok') {
          setVendors(response.data.data);
        } else {
          setMessage(response.data.message);
        }
      } catch (err) {
        setMessage('Error fetching vendors: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchVendors();
  }, []);

  const handleView = (id) => {
    window.location.href = `/ViewVendor/${id}`;
  };
  const openOnboardModal = (vendorId) => {
    setOnboardVendorId(vendorId);
    setShowModal(true);
  };

  const calculateExpiryDate = (startDate, expiryDays) => {
    const start = new Date(startDate);
    const expiry = new Date(start);
    switch (expiryDays) {
      case '1 month': expiry.setMonth(expiry.getMonth() + 1); break;
      case '3 month': expiry.setMonth(expiry.getMonth() + 3); break;
      case '6 month': expiry.setMonth(expiry.getMonth() + 6); break;
      case '1 Year': expiry.setFullYear(expiry.getFullYear() + 1); break;
      default: break;
    }
    return expiry.toISOString().split('T')[0]; // Format as yyyy-mm-dd
  };
  
  const handleOnboardSubmit = async () => {
    if (!businessType || !expiryDays || !startDate) {
      toast.error('All fields are required'); // Show error toast
      return;
    }
    const expiry = calculateExpiryDate(startDate, expiryDays);
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/onboardVendor`, {
        vendorId: onboardVendorId,
        businessType,
        expiryDays,
        startDate,
        expiryDate: expiry
      });
      if (res.data.status === 'ok') {
        toast.success('Vendor onboarded successfully'); // Show success toast
        setShowModal(false);
        setBusinessType('');
        setExpiryDays('');
        setStartDate('');
        setExpiryDate('');
      } else {
        toast.error(res.data.message); // Show error toast
      }
    } catch (err) {
      toast.error('Error: ' + err.message); // Show error toast
    }
  };
  return (
    <>
    <ToastContainer />
      <Sidebar />
      
      <div className="container-fluid p-4">
        <div className="card shadow-sm rounded">
          <div className="card-body">
            <h3 className="text-center text-primary mb-4">All Expired Vendors</h3>
            {loading ? (
              <p>Loading vendors...</p>
            )  : vendors.length ? (
              <table className="table table-striped table-hover text-center">
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Company</th>
                    <th>Number</th>
                    <th>Pincode</th>
                    <th>Added On</th>
                    <th>Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Actions</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {vendors.map((v, i) => (
                    <tr key={v._id}>
                      <td>{i + 1}</td>
                      <td>{v.contactPerson}</td>
                      <td>{v.businessName}</td>
                      <td>{v.contactNumber}</td>
                      <td>{v.pincode}</td>
                      <td>{new Date(v.createdAt).toLocaleDateString('en-IN')}</td>
                      <td>
                        <span className={`badge ${v.approved === true ? 'bg-success' : v.approved === false ? 'bg-danger' : 'bg-warning text-dark'}`}>
                          {v.approved === true ? 'Approved' : v.approved === false ? 'Rejected' : 'Pending'}
                        </span>
                      </td>
                      <td>
                      {new Date(v.startDate).toLocaleDateString('en-IN')}
                    
                      </td>
                      <td style={{color:"red"}}>
                      {new Date(v.expiryDate).toLocaleDateString('en-IN')}
                     
                      </td>
                      <td>
                      <button className="btn btn-sm btn-outline-primary me-2" onClick={() => openOnboardModal(v._id)}>Add Onboard</button>
                      </td>
                      <td>
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => handleView(v._id)}>View</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No vendors found.</p>
            )}
          </div>
        </div>
      </div>
      
      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Onboard Vendor</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Business Type</label>
                  <div>
                    <label className="me-3">
                      <input type="radio" value="Residential" checked={businessType === 'Residential'} onChange={e => setBusinessType(e.target.value)} /> Residential
                    </label>
                    <label>
                      <input type="radio" value="Commercial" checked={businessType === 'Commercial'} onChange={e => setBusinessType(e.target.value)} /> Commercial
                    </label>
                       <label>
                      <input type="radio" value="Both" checked={businessType === 'Both'} onChange={e => setBusinessType(e.target.value)} /> Both
                    </label>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Start Date</label>
                  <input type="date" className="form-control" value={startDate} onChange={e => setStartDate(e.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Expiry Duration</label>
                  <select className="form-control" value={expiryDays} onChange={e => setExpiryDays(e.target.value)}>
                    <option value="">Select</option>
                    <option value="1 month">1 month</option>
                    <option value="3 month">3 month</option>
                    <option value="6 month">6 month</option>
                    <option value="1 Year">1 Year</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleOnboardSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpiredVendors;
